// Collection quantity increment/decrement controls
document.addEventListener('click', (e) => {
  const dec = e.target.closest('.qty-decrement')
  const inc = e.target.closest('.qty-increment')

  const btn = dec || inc
  if (!btn) return

  const container = btn.closest('.product-qty')
  if (!container) return

  const input = container.querySelector('.qty-input')
  if (!input) return

  let value = parseInt(input.value, 10) || 1

  if (dec) value = Math.max(1, value - 1)
  if (inc) value = value + 1

  input.value = value
  input.dispatchEvent(new Event('change', { bubbles: true }))
})

// Ensure manual edits respect minimum
document.addEventListener('change', (e) => {
  if (!e.target.matches('.qty-input')) return
  const input = e.target
  let value = parseInt(input.value, 10) || 1
  if (value < 1) value = 1
  input.value = value
})

// Optional: allow arrow keys + / - handling on focused inputs
document.addEventListener('keydown', (e) => {
  if (!e.target.matches('.qty-input')) return
  if (e.key === 'ArrowUp') {
    e.preventDefault()
    e.target.stepUp()
    e.target.dispatchEvent(new Event('change', { bubbles: true }))
  } else if (e.key === 'ArrowDown') {
    e.preventDefault()
    e.target.stepDown()
    if (parseInt(e.target.value, 10) < 1) e.target.value = 1
    e.target.dispatchEvent(new Event('change', { bubbles: true }))
  }
})
